// document ready
jQuery( document ).ready( function($) {

	// check for simple slider to be initialized
	if ( $( '.who-block-simple-slider' ).length ) {
		$( '.who-block-simple-slider .simple-slider__wrapper' ).each( function() {
			$(this).slick( {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"/></svg></button>',
				prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"/></svg></button>',
			} )
		} )
	}

	// check for simple slider to be initialized
	if ( $( '.who-block-products-slider' ).length ) {
		$( '.who-block-products-slider .products-slider__wrapper' ).each( function() {
			$(this).slick( {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				// autoplay: true,
				// autoplaySpeed: 5000, // uncomment after tests
				fade: true,
				cssEase: 'linear',
				nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"/></svg></button>',
				prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"/></svg></button>',
			} )
		} )

		// For each slider, refresh the tabs on slide change
		$( '.who-block-products-slider .products-slider__wrapper' ).on( 'afterChange', () => {
			$( '.products-slider__item__tabs__content' ).slideUp()
		} )

		// Use products as dots for slider
		$( '.products-slider__tabs__gamme__product' ).on( 'click', function() {
			let index = parseInt( $( this ).attr( 'data-slick-index' ) )
			$( this ).closest( '.who-block-products-slider' ).find( '.products-slider__wrapper' ).slick( 'slickGoTo', index )
		} )

		// To prevent multiple tooltips/clicks
		$( '.products-slider__tooltip' ).on( 'click', ( e ) => {
			let is_active = $( e.currentTarget ).hasClass( 'active' )
			$( '.products-slider__tooltip' ).removeClass( 'active' )

			if ( ! is_active ) {
				$( e.currentTarget ).addClass( 'active' )
			}
		} )

		// Manage tooltip overflow for each one
		document.querySelectorAll( '.products-slider__tooltip' ).forEach( ( el ) => {
			let tooltip = el.querySelector('.products-slider__tooltip__description')

			handle_tooltip_overflow( el, tooltip )
		} )

		// Handle click on tab to show associated tab content
		$( '.products-slider__item__tabs__action' ).on( 'click', function() {
			let slick_index = parseInt( $( this ).attr( 'data-slick-index' ) )
			let tab_index   = $( this ).attr( 'data-tab-index' )

			let $tabs = $( '.products-slider__item__tabs__content' )
			let $tab  = $( '.products-slider__item__tabs__content[data-tab-index="' + tab_index + '"][data-slick-index="' + slick_index + '"]' )

			let is_active = $tab.is(':visible')
			$tabs.slideUp()

			if ( ! is_active ) {
				$tab.slideDown()
			}
		} )

		// Handle click on feeding guide tab to show associated tab content
		$( '.products-slider__feeding__tabs__tab' ).on( 'click', function() {
			let index          = parseInt( $( this ).attr( 'data-tab-index' ) )
			let $tab           = $( this )
			let $tabs          = $( this ).siblings( '.products-slider__feeding__tabs__tab' )
			let $tab__content  = $( this ).closest( '.products-slider__feeding__tabs' ).siblings( '.products-slider__feeding__content[data-tab-index="' + index + '"]' )
			let $tabs__content = $( this ).closest( '.products-slider__feeding__tabs' ).siblings( '.products-slider__feeding__content' )

			let is_active = $tab.hasClass( 'active' )
			
			if ( ! is_active ) {
				$tabs.removeClass( 'active' )
				$tabs__content.removeClass( 'active' )
				$tab.addClass( 'active' )
				$tab__content.addClass( 'active' )
			}
		} )

		/**
		 * Handle tooltip overflow for an element and its tooltip
		 * @param {HTMLElement} el 
		 * @param {HTMLElement} tooltip 
		 */
		function handle_tooltip_overflow( el, tooltip ) {
			const screenPadding = 16
			
			const element_rect = el.getBoundingClientRect()
			const tooltip_rect = tooltip.getBoundingClientRect()
			
			const tooltip_right_x = tooltip_rect.x + tooltip_rect.width
			const element_right_x = element_rect.x + element_rect.width

			// If the tooltip overflows the screen on the left
			if ( tooltip_rect.x < 0 ) {
				tooltip.style.left      = '0'
				tooltip.style.right     = 'auto'
				tooltip.style.transform = `translateX(${ - element_rect.x + screenPadding }px)`
			} 
			// If the tooltip overflows the screen on the right
			else if ( tooltip_right_x > window.outerWidth ) {
				tooltip.style.left      = 'auto'
				tooltip.style.right     = '0'
				tooltip.style.transform = `translateX(${ ( window.outerWidth - element_right_x ) - screenPadding }px)`
			}
		}
	}
} )